import { render } from "./pageFooter.vue?vue&type=template&id=6c4307bf&scoped=true"
import script from "./pageFooter.vue?vue&type=script&lang=js"
export * from "./pageFooter.vue?vue&type=script&lang=js"

import "./pageFooter.vue?vue&type=style&index=0&id=6c4307bf&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c4307bf"]])

export default __exports__